module.exports = "/_next/static/images/ama-reference-list-a15ff2f92356c346dc4c9a8eab179e0e.png";